import { Accessor, Show, useContext } from 'solid-js';
import { Button } from '../../ui-components/button/button';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { BasketContext } from './basket-context-provider';
import { cviSemantic } from '../../style/theme';

const BasketOrderSummary = ({ isPlacingOrder, createOrder }: { isPlacingOrder: Accessor<boolean>; createOrder: () => void }) => {
    const { productsListingPage, userState, localize } = useContext(AppContext);
    const { basket } = useContext(BasketContext);
    const { appStore } = useContext(AppContext);
    const { openLoginMenu } = appStore;

    return (
        <Show when={basket.order.orderDetails.length}>
            <div class="flex flex-col-reverse items-stretch gap-cvi-6 pt-cvi-9 tablet:flex-row tablet:items-center tablet:justify-end">
                <Show when={productsListingPage.url}>
                    <Button
                        label={localize('back-to-products', 'Back to products')}
                        variant='ghost'
                        iconStart="arrow-left"
                        isLink
                        url={productsListingPage.url}
                        noBlockSpacing
                    />
                </Show>

                <Show when={!userState.user}>
                    <Button
                        label={localize('login-to-order', 'Login to place an order')}
                        onClick={() => openLoginMenu()}
                        noBlockSpacing
                    />
                </Show>

                <Show when={userState.user}>
                    {/* `w-fit` so the absolutely-placed spinner anchors to the button and not to
                       the full-width row the mobile `items-stretch` would otherwise give it. */}
                    <div class="relative w-fit">
                        <Button
                            label={isPlacingOrder()
                                ? localize('placing-order', 'Placing order...')
                                : localize('place-order', 'Place order')
                            }
                            disabled={isPlacingOrder()}
                            onClick={() => createOrder()}
                            /* Reserves the spinner's lane (24px padding + 20px spinner + 12px gap)
                               so it never lands on top of the label. */
                            customCss={isPlacingOrder() ? 'pr-cvi-12' : undefined}
                            noBlockSpacing
                        />
                        {/* Deliberately a sibling of the button, not a child: `disabled` drops the
                           button to 0.3 opacity, which would drag a nested spinner down with it.
                           Brand rather than on-color for the same reason — white would vanish
                           against the washed-out primary fill. */}
                        <Show when={isPlacingOrder()}>
                            <div class="absolute right-cvi-8 top-1/2 -translate-y-1/2 opacity-0 animate-fade-in">
                                <LoadingSpinner size="20px" thickness="3px" color={cviSemantic.fgBrand} />
                            </div>
                        </Show>
                    </div>
                </Show>
            </div>
        </Show>
    );
};

export default BasketOrderSummary;
